import React, { useState } from 'react';
import { Box, Card, CardContent, Typography, TextField, Button, Grid } from '@mui/material';
import yaml from 'js-yaml';

export default function RoutingRulesEditorForm({ initialData, onSave }) {
  // initialData: { tags: {...}, classification: {...} }
  const [tags, setTags] = useState(initialData?.tags || {
    lexifi_instance_name: '',
    lexifi_product_type: '',
    source: ''
  });
  const [newTagName, setNewTagName] = useState('');
  const [classification, setClassification] = useState(initialData?.classification || {
    product_type_name: ''
  });
  const [yamlText, setYamlText] = useState('');

  // Update YAML preview when fields change
  React.useEffect(() => {
    const obj = {
      tags,
      classification
    };
    setYamlText(yaml.dump(obj));
  }, [tags, classification]);

  const handleTagChange = (key, value) => {
    setTags(prev => ({ ...prev, [key]: value }));
  };
  const handleClassificationChange = (key, value) => {
    setClassification(prev => ({ ...prev, [key]: value }));
  };

  const handleAddTag = () => {
    const tagName = newTagName.trim();
    if (tagName && !(tagName in tags)) {
      setTags(prev => ({ ...prev, [tagName]: '' }));
      setNewTagName('');
    }
  };

  const handleDeleteTag = (key) => {
    setTags(prev => {
      const updated = { ...prev };
      delete updated[key];
      return updated;
    });
  };

  return (
    <Card sx={{ mt: 4 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>Routing Rule Editor</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1">Tags</Typography>
            {Object.keys(tags).map(key => (
              <Box key={key} sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <TextField
                  label={key}
                  value={tags[key]}
                  onChange={e => handleTagChange(key, e.target.value)}
                  fullWidth
                  sx={{ mr: 1 }}
                />
                <Button variant="outlined" color="error" size="small" onClick={() => handleDeleteTag(key)}>
                  Delete
                </Button>
              </Box>
            ))}
            <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
              <TextField
                label="New Tag Name"
                value={newTagName}
                onChange={e => setNewTagName(e.target.value)}
                size="small"
                sx={{ flex: 1 }}
              />
              <Button variant="outlined" onClick={handleAddTag} disabled={!newTagName.trim() || tags[newTagName.trim()] !== undefined}>
                Add Tag
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1">Classification</Typography>
            {Object.keys(classification).map(key => (
              <TextField
                key={key}
                label={key}
                value={classification[key]}
                onChange={e => handleClassificationChange(key, e.target.value)}
                fullWidth
                sx={{ mb: 2 }}
              />
            ))}
          </Grid>
        </Grid>
        <Box sx={{ mt: 3 }}>
          <Typography variant="subtitle2">YAML Preview</Typography>
          <pre style={{ background: '#f5f5f5', padding: 16 }}>{yamlText}</pre>
        </Box>
        <Button variant="contained" sx={{ mt: 2 }} onClick={() => onSave && onSave({ tags, classification })}>
          Save
        </Button>
      </CardContent>
    </Card>
  );
}
